import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TribeMembership } from '../types';

export default function TribesInCommon({
  memberships = [],
  memberIds = [],
}: {
  memberships?: TribeMembership[];
  memberIds?: string[];
}) {
  const { t } = useTranslation('users') as {
    t: (key: string, options?: Record<string, unknown>) => string;
  };

  const commonMemberships = useMemo(
    () =>
      memberships.filter(
        membership =>
          membership.tribe && memberIds.includes(membership.tribe._id),
      ),
    [memberIds, memberships],
  );

  if (commonMemberships.length === 0) {
    return null;
  }

  return (
    <div className="profile-tribes-common">
      <h4>{t('Circles in common')}</h4>
      <ul className="list-inline">
        {commonMemberships.map(membership => (
          <li key={membership.tribe._id}>
            <a
              className="tribe-link"
              href={`/circles/${membership.tribe.slug}`}
            >
              {membership.tribe.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
